import { call, takeLatest, put, } from 'redux-saga/effects';
import { getStoreSummaryFailure, getStoreSummaryRequest, getStoreSummarySuccess, getSingleStoreDetailsRequest, getSingleStoreDetailsSuccess, getSingleStoreDetailsFailure  } from '../actions/storeActions';
import { makeStoreListCall, makeSingleStoreDetailsCall } from '../../api/storePageAPI';

export function* makeStoreListCallSaga(action) {
	try {
		const response = yield call(makeStoreListCall, action);
		// console.log('CHECK ',response)
		if (response?.status === 200) {
			yield put(getStoreSummarySuccess(response.data));
		 } else {
			yield put(getStoreSummaryFailure(response));
		 }
	  } catch (e) {
		yield put(getStoreSummaryFailure(e.message));
	}
}

export function* makeSingleStoreDetailsCallSaga(action) {
	try {
		const response = yield call(makeSingleStoreDetailsCall, action);
		yield put(getSingleStoreDetailsSuccess(response));
	} catch (e) {
		yield put(getSingleStoreDetailsFailure(e.message));
	}
}

function* storesPageSaga() {
	yield takeLatest(getStoreSummaryRequest, makeStoreListCallSaga);
	yield takeLatest(getSingleStoreDetailsRequest, makeSingleStoreDetailsCallSaga);
}

export default storesPageSaga;
